// wishlist.js — FIXED VERSION (variant-safe)

const WISHLIST_KEY = 'myWishlist';

/* ===============================
   Helpers
================================ */
function getWishlist() {
  return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
}

function saveWishlist(list) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
}

function syncWishlistUI() {
  const wishlist = getWishlist();

  document.querySelectorAll('.wishlist-btn-heart').forEach(btn => {
    const variantId = parseInt(btn.dataset.variantId, 10);
    if (Number.isNaN(variantId)) return;

   // ONLY toggle this button individually
    if (wishlist.includes(variantId)) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });
}

/* ===============================
   Click handler (delegated)
================================ */
document.addEventListener('click', function (event) {
  const btn = event.target.closest(
    '.wishlist-btn-heart, .wishlist-login-heart'
  );

  if (!btn) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  /* Logged-out user → redirect */
  if (btn.classList.contains('wishlist-login-heart')) {
    const loginUrl = btn.getAttribute('href');
    if (loginUrl) window.location.href = loginUrl;
    return;
  }

  const variantId = parseInt(btn.dataset.variantId, 10);
  if (Number.isNaN(variantId)) return;

  let wishlist = getWishlist();

  if (wishlist.includes(variantId)) {
    wishlist = wishlist.filter(id => id !== variantId);
  } else {
    wishlist.push(variantId);
  }

  saveWishlist(wishlist);
  syncWishlistUI();
});

/* ===============================
   Restore on page load
================================ */
document.addEventListener('DOMContentLoaded', syncWishlistUI);